class headerDropdown extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('mouseenter', () => {
            this.setAttribute('data-dropdown-open', '');
        })

        this.addEventListener('mouseleave', () => {
            this.removeAttribute('data-dropdown-open');
        })
        // ensure clicked on text, close when clicked anywhere else
    }
}

customElements.define("cstm-header-dropdown", headerDropdown);